











































import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue';
import { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import DialogoDeEdicaoCadastroTamanhoDeEtiqueta from './DialogoDeEdicaoCadastroTamanhoDeEtiqueta.vue';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import  { CancelToken } from 'axios';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import { Pageable, Page } from '@/models';
import { type EtiquetaDePrecoServiceAdapter } from '@/usecases';


@Component({
	components: {
		DataTableDeCrudPaginado,
		DialogoDeEdicaoCadastroTamanhoDeEtiqueta,
	},
})

export default class TelaDeCadastroTamanhoDeEtiqueta extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicaoCadastroTamanhoDeEtiqueta!: DialogoDeEdicaoCadastroTamanhoDeEtiqueta

	busca = ''
	carregando = false
	editando = false
	tamanhoDaEtiqueta: TamanhoDaEtiqueta | null = null
	listaTamanhosDeEtiqueta: TamanhoDaEtiqueta[] = [];

	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter

	headers = [
		{ text: 'Descrição', value: 'descricao', sortable: false },
		{ text: 'Grupo Econômico', value: 'grupoEconomico.descricao', sortable: false},
	]

	async buscar(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<TamanhoDaEtiqueta>> {
		const page = await this.etiquetaDePrecoService.findTamanhoDeEtiqueta({...parametros, ...paginavel}, {cancelToken})
		this.listaTamanhosDeEtiqueta = page.content
		return page
	}


	abrirDialogoDeEditartamanhoDaEtiqueta(indice: number) {
		try {
			if(!this.temRecurso('alterar', "tamanhos-de-etiqueta")) {
				throw new Error('Necessário permissão para editar')
			}
			this.editando = true
			this.tamanhoDaEtiqueta = this.listaTamanhosDeEtiqueta[indice]

			this.dialogoDeEdicaoCadastroTamanhoDeEtiqueta.mostrar(this.tamanhoDaEtiqueta, this.editando)
			this.dialogoDeEdicaoCadastroTamanhoDeEtiqueta.$on('sucesso', this.buscar)
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	abrirDialogoDeCriartamanhoDaEtiqueta() {
		try {
			if(!this.temRecurso('criar', 'tamanhos-de-etiqueta')) 
				throw new Error('Necessário permissão para criar')
			this.editando = false
			this.tamanhoDaEtiqueta = {
				id: '',
				descricao: '',
				grupoEconomico: null,
				impressaoUnica: false,
				larguraPagina: 0,
				alturaPagina: 0,
				larguraEtiqueta: 0,
				alturaEtiqueta: 0,
				bordaEsquerda: 0,
				distanciaEntreEtiquetas: 0,
				bordaDoTopo: 0,
			} as TamanhoDaEtiqueta

			this.dialogoDeEdicaoCadastroTamanhoDeEtiqueta.mostrar(this.tamanhoDaEtiqueta, this.editando)
			this.dialogoDeEdicaoCadastroTamanhoDeEtiqueta.$on('sucesso', this.buscar)
		} catch(error) {
			AlertModule.setError(error)
		}
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}

}
